import ListFakturPenjualan from './ListFakturPenjualan'

export default ListFakturPenjualan